'use client';
import { ForwardedRef, forwardRef } from 'react';

import { Action, FilterSection } from '~/components';
import { Button } from '@bgzt/ui';
import { FilterValue } from '~/apis/search';
import { convertPayload } from '~/components/FilterBottomSheet/_utils/payload-utils';

import styles from './SingleButton.module.css';

type Props = {
  onChange: (action: Action) => void;
  options: FilterValue[];
  value: string;
  filterKey: string;
  title: string;
};

export const SingleButton = forwardRef(function SingleButton(
  { onChange, options, value: currentValue, filterKey, title }: Props,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return (
    <FilterSection title={title} ref={ref}>
      <div className={styles.container}>
        {options.map(({ name, value }) => (
          <Button
            variant={(value ?? '') === currentValue ? 'secondaryRed' : 'normalLine'}
            key={name + value}
            onClick={() => {
              onChange({ type: filterKey, payload: convertPayload(value) });
            }}
          >
            {name}
          </Button>
        ))}
      </div>
    </FilterSection>
  );
});
